import React from "react";

const DashboardMetrics = ({ metrics }) => {
  const metricsData = [
    {
      label: "TOTAL USERS",
      value: metrics.totalUsers?.toLocaleString() || 0,
    },
    {
      label: "TOTAL PLAYERS",
      value: metrics.totalPlayers?.toLocaleString() || 0,
    },
    {
      label: "CLAIMED PROFILES",
      value: metrics.totalClaimedProfiles?.toLocaleString() || 0,
    },
    {
      label: "TOTAL COACHES",
      value: metrics.totalCoaches?.toLocaleString() || 0,
    },
    {
      label: "TOTAL SCOUTS",
      value: metrics.totalScouts?.toLocaleString() || 0,
    },
    {
      label: "PENDING APPROVALS",
      value: metrics.pendingApprovals || 0,
      highlight: true,
    },
  ];

  return (
    <div className="rounded-3xl bg-jp-band border border-jp-outline/70 shadow-sm p-6 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-6">
      {metricsData.map((metric) => (
        <div key={metric.label} className="flex flex-col items-start gap-1">
          <span className="text-cyan-300 text-[11px] font-bold uppercase tracking-widest">
            {metric.label}
          </span>
          <span className={`text-3xl font-anton tracking-tight ${metric.highlight ? 'text-yellow-300' : 'text-white'}`}>
            {metric.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default DashboardMetrics;
